
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration/[type]",
      function () {
        return require("private-next-pages/registration/[type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration/[type]"])
      });
    }
  